import { RiArrowLeftLine } from "@remixicon/react";
import { Button } from "@workspace/ui/components/button";
import { Card } from "@workspace/ui/components/card";
import { useRouter } from "next/navigation";
import { useCallback } from "react";

interface FestivalErrorStateProps {
	hasError: boolean;
	errorMessage?: string;
}

export function FestivalErrorState({
	hasError,
	errorMessage,
}: FestivalErrorStateProps) {
	const router = useRouter();

	const handleBack = useCallback(() => {
		if (window.history.length > 1) {
			router.back();
		} else {
			router.push("/festivals");
		}
	}, [router]);

	return (
		<div className="flex min-h-screen flex-col p-4">
			<Button
				variant="secondary"
				size="sm"
				onClick={handleBack}
				className="mb-4 inline-flex w-fit items-center text-sm"
			>
				<RiArrowLeftLine className="mr-1 h-4 w-4" />
				<span>Back</span>
			</Button>
			<Card>
				<div className="p-6">
					<h1 className="mb-2 font-semibold text-xl">
						{hasError ? "Error" : "Not Found"}
					</h1>
					<p className="text-muted-foreground">
						{errorMessage ||
							(hasError
								? "Could not load the festival data."
								: "This festival could not be found.")}
					</p>
				</div>
			</Card>
		</div>
	);
}
